module.exports = __webpack_public_path__ + "img/dom-pedro-lisboa.7c4ae9e4.jpg";